module.exports = __webpack_public_path__ + "static/media/NW_Intro.d0c03c56.mp4";